var exports = {
  "P": "x31de4314--d60080--label",
};

module.exports = exports;
